/* eslint-disable react/self-closing-comp */
import { useEffect } from 'react'
import { HiOutlineArrowLongRight } from 'react-icons/hi2'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

import { ContainerSectionHeroInternacional } from './styles'
import ArrowCurvedSVG from '../../../../assets/svgs/arrow-curved'
import TrailBackgroundSVG from '../../../../assets/svgs/trail-background'
import useAppConfig from '../../../../hooks/useAppConfig'
import SocialHeaderMenu from '../../../HeadersMenu/SocialHeaderMenu'
import { logFirebaseEvent } from '../../../../services/firebase/analytics'

gsap.registerPlugin(ScrollToPlugin)

export default function SectionHeroInternacional() {
  const { appConfig } = useAppConfig()

  useEffect(() => {
    const selectSVG = window.document.getElementsByClassName(
      'wil-svg-trail-background'
    )
    const selectorBody1 =
      window.document.getElementsByClassName('m-section-left')

    const selectorBody2 =
      window.document.getElementsByClassName('m-section-right')

    gsap.to(selectSVG, {
      opacity: 1,
      duration: 0.6,
    })
    gsap.to(selectorBody1, {
      opacity: 1,
      duration: 0.1,
      marginLeft: 0,
    })
    gsap.to(selectorBody2, {
      opacity: 1,
      duration: 0.6,
      marginRight: 0,
    })
  }, [])

  function onClickButtonAction() {
    const targetElement = document.getElementById(
      'section-services-landing-page'
    ) as Element | undefined

    gsap.to(window, {
      duration: 0.6,
      scrollTo: { y: targetElement, offsetY: 50 },
    })
  }

  const handleANalyticsButtonClick = () => {
    logFirebaseEvent('button_click', {
      button_name: 'see_more_hero',
      screen_name: 'landing_page',
    })
  }

  return (
    <ContainerSectionHeroInternacional
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <TrailBackgroundSVG />
      <SocialHeaderMenu
        appLogo={appConfig?.appConfig?.appLogo}
        appLogoDescription={appConfig?.appConfig?.appDescription}
        actionButtonLabel={appConfig?.appConfig?.appActionLabel}
        actionButtonOnClick={() => {}}
        menuList={appConfig?.appConfig?.appRoutes}
      />
      <div className="middle-section">
        <div className="m-section-left">
          <div className="m-s-l-float-label">
            {appConfig?.appConfig?.appLabel}
            <span>
              <ArrowCurvedSVG />
            </span>
          </div>
          <div className="m-s-l-title">
            {appConfig?.appConfig?.appDescription}
          </div>
          <div
            className="m-s-l-button-action"
            onClick={() => {
              onClickButtonAction()
              handleANalyticsButtonClick()
            }}
            aria-hidden
          >
            {appConfig?.appConfig?.appActionOutlineLabel}
            <HiOutlineArrowLongRight />
          </div>
        </div>
        <div className="m-section-right">
          <div className="radius-box-colored">
            {appConfig?.appConfig?.appHeroExtraLabels?.map(
              (itemFinal, _index) => {
                return (
                  <div
                    key={`item-final-0${_index}`}
                    className={`floating-box-animated-jump type-0${_index + 1}`}
                  >
                    <div className="circular"></div>
                    <div className="label">{itemFinal}</div>
                  </div>
                )
              }
            )}
          </div>
        </div>
      </div>
    </ContainerSectionHeroInternacional>
  )
}
